// Mock data for Teachable Clone

export const mockUsers = {
  instructor: {
    id: 'user_1',
    name: 'Sarah Johnson',
    email: 'sarah@teachable.com',
    role: 'instructor',
    avatar: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=150&h=150&fit=crop',
    bio: 'Senior software engineer with 10+ years experience teaching web development.',
    coursesCreated: 5,
    totalStudents: 12500,
    totalRevenue: 125000
  },
  student: {
    id: 'user_2',
    name: 'Alex Chen',
    email: 'alex@student.com',
    role: 'student',
    avatar: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=150&h=150&fit=crop',
    enrolledCourses: ['course_1', 'course_2'],
    completedCourses: ['course_3']
  },
  admin: {
    id: 'user_admin',
    name: 'Admin User',
    email: 'admin@teachable.com',
    role: 'admin',
    avatar: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=150&h=150&fit=crop'
  }
};

export const mockCourses = [
  {
    id: 'course_1',
    title: 'Complete Web Development Bootcamp 2025',
    slug: 'web-development-bootcamp',
    description: 'Learn HTML, CSS, JavaScript, React, Node.js and more. Build real-world projects and launch your career as a full-stack developer.',
    shortDescription: 'Master full-stack development from scratch',
    thumbnail: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_1',
      name: 'Sarah Johnson',
      avatar: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=150&h=150&fit=crop'
    },
    price: 199.99,
    originalPrice: 299.99,
    currency: 'USD',
    category: 'Development',
    level: 'Beginner to Advanced',
    duration: '52 hours',
    totalLessons: 245,
    totalStudents: 8420,
    rating: 4.8,
    reviewsCount: 1256,
    language: 'English',
    lastUpdated: '2025-06-15',
    published: true,
    featured: true,
    sections: [
      {
        id: 'section_1',
        title: 'Getting Started with Web Development',
        lessons: [
          { id: 'lesson_1', title: 'Welcome to the Course', type: 'video', duration: '5:30', videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ', completed: true },
          { id: 'lesson_2', title: 'How the Web Works', type: 'video', duration: '12:45', videoUrl: 'https://www.youtube.com/watch?v=hJHvdBlSxug', completed: true },
          { id: 'lesson_3', title: 'Setting Up Your Development Environment', type: 'video', duration: '18:20', videoUrl: 'https://www.youtube.com/watch?v=VwIoPrgMbm0', completed: false },
          { id: 'lesson_4', title: 'Quiz: Web Fundamentals', type: 'quiz', questions: 10, completed: false }
        ]
      },
      {
        id: 'section_2',
        title: 'HTML5 Fundamentals',
        lessons: [
          { id: 'lesson_5', title: 'Introduction to HTML', type: 'video', duration: '15:00', videoUrl: 'https://www.youtube.com/watch?v=UB1O30fR-EE', completed: false },
          { id: 'lesson_6', title: 'HTML Document Structure', type: 'video', duration: '20:30', videoUrl: 'https://www.youtube.com/watch?v=UB1O30fR-EE', completed: false },
          { id: 'lesson_7', title: 'Working with Forms', type: 'video', duration: '25:15', videoUrl: 'https://www.youtube.com/watch?v=UB1O30fR-EE', completed: false },
          { id: 'lesson_8', title: 'Semantic HTML', type: 'video', duration: '18:45', videoUrl: 'https://www.youtube.com/watch?v=UB1O30fR-EE', completed: false }
        ]
      },
      {
        id: 'section_3',
        title: 'CSS3 Mastery',
        lessons: [
          { id: 'lesson_9', title: 'CSS Basics & Selectors', type: 'video', duration: '22:00', videoUrl: 'https://www.youtube.com/watch?v=1PnVor36_40', completed: false },
          { id: 'lesson_10', title: 'Flexbox & Grid Layout', type: 'video', duration: '35:20', videoUrl: 'https://www.youtube.com/watch?v=1PnVor36_40', completed: false },
          { id: 'lesson_11', title: 'Responsive Design', type: 'video', duration: '28:15', videoUrl: 'https://www.youtube.com/watch?v=1PnVor36_40', completed: false }
        ]
      }
    ],
    whatYouWillLearn: [
      'Build 16+ real-world web development projects',
      'Master HTML5, CSS3, JavaScript ES6+',
      'Learn React.js and build modern SPAs',
      'Backend development with Node.js & Express',
      'Database design with MongoDB',
      'Deploy applications to production'
    ],
    requirements: [
      'No prior programming experience required',
      'A computer with internet access',
      'Enthusiasm to learn!'
    ]
  },
  {
    id: 'course_2',
    title: 'Python for Data Science & Machine Learning',
    slug: 'python-data-science',
    description: 'Master Python programming for data analysis, visualization, and machine learning. Learn NumPy, Pandas, Matplotlib, Scikit-learn, and TensorFlow.',
    shortDescription: 'From Python basics to advanced ML',
    thumbnail: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_3',
      name: 'Dr. Michael Torres',
      avatar: 'https://images.unsplash.com/photo-1622295023876-0cdf583c41f6?w=150&h=150&fit=crop'
    },
    price: 149.99,
    originalPrice: 249.99,
    currency: 'USD',
    category: 'Data Science',
    level: 'Intermediate',
    duration: '45 hours',
    totalLessons: 180,
    totalStudents: 6350,
    rating: 4.9,
    reviewsCount: 892,
    language: 'English',
    lastUpdated: '2025-05-20',
    published: true,
    featured: true,
    sections: [
      {
        id: 'section_1',
        title: 'Python Fundamentals',
        lessons: [
          { id: 'lesson_1', title: 'Introduction to Python', type: 'video', duration: '10:00', videoUrl: 'https://www.youtube.com/watch?v=rfscVS0vtbw', completed: false },
          { id: 'lesson_2', title: 'Variables and Data Types', type: 'video', duration: '18:30', videoUrl: 'https://www.youtube.com/watch?v=rfscVS0vtbw', completed: false }
        ]
      }
    ],
    whatYouWillLearn: [
      'Python programming from scratch',
      'Data manipulation with Pandas',
      'Data visualization with Matplotlib',
      'Machine learning with Scikit-learn',
      'Deep learning with TensorFlow'
    ],
    requirements: [
      'Basic programming knowledge helpful',
      'High school math'
    ]
  },
  {
    id: 'course_3',
    title: 'Digital Photography Masterclass',
    slug: 'digital-photography',
    description: 'Learn professional photography techniques, camera settings, composition, lighting, and post-processing in Lightroom and Photoshop.',
    shortDescription: 'Capture stunning photos like a pro',
    thumbnail: 'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_4',
      name: 'Emma Wilson',
      avatar: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=150&h=150&fit=crop'
    },
    price: 89.99,
    originalPrice: 149.99,
    currency: 'USD',
    category: 'Photography',
    level: 'All Levels',
    duration: '28 hours',
    totalLessons: 95,
    totalStudents: 4200,
    rating: 4.7,
    reviewsCount: 567,
    language: 'English',
    lastUpdated: '2025-04-10',
    published: true,
    featured: false,
    sections: [],
    whatYouWillLearn: [
      'Master camera settings',
      'Composition techniques',
      'Professional lighting',
      'Photo editing in Lightroom'
    ],
    requirements: ['A digital camera or smartphone']
  },
  {
    id: 'course_4',
    title: 'Business Strategy & Entrepreneurship',
    slug: 'business-strategy',
    description: 'Learn how to start, grow, and scale a successful business. Covers business planning, marketing, finance, and leadership.',
    shortDescription: 'Build your business empire',
    thumbnail: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_5',
      name: 'James Rodriguez',
      avatar: 'https://images.unsplash.com/photo-1580894732930-0babd100d356?w=150&h=150&fit=crop'
    },
    price: 179.99,
    originalPrice: 299.99,
    currency: 'USD',
    category: 'Business',
    level: 'Intermediate',
    duration: '35 hours',
    totalLessons: 120,
    totalStudents: 3800,
    rating: 4.6,
    reviewsCount: 445,
    language: 'English',
    lastUpdated: '2025-03-25',
    published: true,
    featured: true,
    sections: [],
    whatYouWillLearn: [
      'Business planning fundamentals',
      'Marketing strategies',
      'Financial management',
      'Leadership skills'
    ],
    requirements: ['No prior experience needed']
  },
  {
    id: 'course_5',
    title: 'Spanish Language Complete Course',
    slug: 'spanish-complete',
    description: 'Master Spanish from beginner to advanced. Includes vocabulary, grammar, conversation practice, and cultural insights.',
    shortDescription: 'Speak Spanish fluently',
    thumbnail: 'https://images.pexels.com/photos/301926/pexels-photo-301926.jpeg?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_6',
      name: 'Maria Garcia',
      avatar: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=150&h=150&fit=crop'
    },
    price: 129.99,
    originalPrice: 199.99,
    currency: 'USD',
    category: 'Language',
    level: 'Beginner',
    duration: '40 hours',
    totalLessons: 200,
    totalStudents: 5600,
    rating: 4.8,
    reviewsCount: 723,
    language: 'English',
    lastUpdated: '2025-06-01',
    published: true,
    featured: false,
    sections: [],
    whatYouWillLearn: [
      'Spanish vocabulary & grammar',
      'Conversational Spanish',
      'Reading & writing skills',
      'Cultural understanding'
    ],
    requirements: ['No prior Spanish knowledge required']
  },
  {
    id: 'course_6',
    title: 'Fitness & Nutrition Fundamentals',
    slug: 'fitness-nutrition',
    description: 'Transform your health with science-based fitness and nutrition. Includes workout plans, meal prep guides, and habit formation.',
    shortDescription: 'Transform your health & fitness',
    thumbnail: 'https://images.pexels.com/photos/5088181/pexels-photo-5088181.jpeg?w=600&h=400&fit=crop',
    instructor: {
      id: 'user_7',
      name: 'Chris Anderson',
      avatar: 'https://images.unsplash.com/photo-1622295023876-0cdf583c41f6?w=150&h=150&fit=crop'
    },
    price: 79.99,
    originalPrice: 129.99,
    currency: 'USD',
    category: 'Health & Fitness',
    level: 'All Levels',
    duration: '20 hours',
    totalLessons: 75,
    totalStudents: 7200,
    rating: 4.7,
    reviewsCount: 890,
    language: 'English',
    lastUpdated: '2025-05-15',
    published: true,
    featured: false,
    sections: [],
    whatYouWillLearn: [
      'Effective workout routines',
      'Nutrition science basics',
      'Meal planning & prep',
      'Building healthy habits'
    ],
    requirements: ['Willingness to change']
  }
];

export const mockCategories = [
  { id: 'cat_1', name: 'BaZi', icon: 'Compass', count: 24 },
  { id: 'cat_2', name: 'Feng Shui', icon: 'Home', count: 18 },
  { id: 'cat_3', name: 'QiMen', icon: 'Grid3X3', count: 15 },
  { id: 'cat_4', name: 'Face Reading', icon: 'User', count: 12 },
  { id: 'cat_5', name: 'Numerology', icon: 'Hash', count: 10 },
  { id: 'cat_6', name: 'Date Selection', icon: 'Calendar', count: 8 },
  { id: 'cat_7', name: 'Yi Jing', icon: 'BookOpen', count: 6 },
  { id: 'cat_8', name: 'Astrology', icon: 'Star', count: 5 }
];

export const mockTestimonials = [
  {
    id: 'test_1',
    name: 'Jennifer Tan',
    role: 'Business Owner',
    avatar: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=150&h=150&fit=crop',
    content: 'The BaZi wealth course completely changed how I approach business decisions. I finally understand my timing and have made my best investments following Master Tong\'s teachings.',
    rating: 5,
    course: 'Grow Your Wealth With BaZi'
  },
  {
    id: 'test_2',
    name: 'Michael Wong',
    role: 'Real Estate Investor',
    avatar: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=150&h=150&fit=crop',
    content: 'QiMen has become my secret weapon for deal negotiations. The forecasting accuracy is remarkable - I wish I had learned this 20 years ago.',
    rating: 5,
    course: 'QiMen Forecasting'
  },
  {
    id: 'test_3',
    name: 'Sarah Lim',
    role: 'HR Director',
    avatar: 'https://images.pexels.com/photos/6238046/pexels-photo-6238046.jpeg?w=150&h=150&fit=crop',
    content: 'Face Reading has transformed how I conduct interviews. I can now quickly assess candidates and build better teams. The ROI on this course has been incredible.',
    rating: 5,
    course: 'Face Reading Masterclass'
  }
];

export const mockStats = {
  totalStudents: '100M+',
  totalCourses: '50,000+',
  totalInstructors: '150,000+',
  countriesReached: '180+',
  totalEarnings: '$10B+'
};

export const mockEnrollments = [
  {
    id: 'enroll_1',
    courseId: 'course_1',
    userId: 'user_2',
    progress: 35,
    completedLessons: ['lesson_1', 'lesson_2'],
    enrolledAt: '2025-05-01',
    lastAccessedAt: '2025-07-15'
  },
  {
    id: 'enroll_2',
    courseId: 'course_2',
    userId: 'user_2',
    progress: 60,
    completedLessons: ['lesson_1'],
    enrolledAt: '2025-04-15',
    lastAccessedAt: '2025-07-14'
  }
];

export const mockReviews = [
  {
    id: 'review_1',
    courseId: 'course_1',
    userId: 'user_2',
    userName: 'Alex Chen',
    userAvatar: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?w=150&h=150&fit=crop',
    rating: 5,
    content: 'Absolutely fantastic course! Sarah explains everything so clearly and the projects are really fun to build.',
    createdAt: '2025-06-20',
    helpful: 245
  },
  {
    id: 'review_2',
    courseId: 'course_1',
    userId: 'user_8',
    userName: 'Michael Brown',
    userAvatar: 'https://images.unsplash.com/photo-1622295023876-0cdf583c41f6?w=150&h=150&fit=crop',
    rating: 5,
    content: 'Best investment I made in my career. Went from complete beginner to employed developer in 6 months.',
    createdAt: '2025-06-15',
    helpful: 189
  },
  {
    id: 'review_3',
    courseId: 'course_1',
    userId: 'user_9',
    userName: 'Emily Davis',
    userAvatar: 'https://images.unsplash.com/photo-1544717305-2782549b5136?w=150&h=150&fit=crop',
    rating: 4,
    content: 'Great content and well structured. Would love to see more advanced topics added in future updates.',
    createdAt: '2025-06-10',
    helpful: 156
  }
];

export const mockAdminStats = {
  totalRevenue: 125000,
  monthlyRevenue: 18500,
  totalStudents: 12500,
  newStudentsThisMonth: 850,
  totalCourses: 25,
  activeCourses: 22,
  completionRate: 68,
  averageRating: 4.7,
  revenueChart: [
    { month: 'Jan', revenue: 12000 },
    { month: 'Feb', revenue: 14500 },
    { month: 'Mar', revenue: 13800 },
    { month: 'Apr', revenue: 16200 },
    { month: 'May', revenue: 17500 },
    { month: 'Jun', revenue: 18500 },
    { month: 'Jul', revenue: 19200 }
  ],
  enrollmentsChart: [
    { month: 'Jan', enrollments: 620 },
    { month: 'Feb', enrollments: 750 },
    { month: 'Mar', enrollments: 680 },
    { month: 'Apr', enrollments: 820 },
    { month: 'May', enrollments: 890 },
    { month: 'Jun', enrollments: 850 },
    { month: 'Jul', enrollments: 920 }
  ]
};

export const mockPayments = [
  {
    id: 'pay_1',
    courseId: 'course_1',
    userId: 'user_2',
    amount: 199.99,
    currency: 'USD',
    status: 'completed',
    paymentMethod: 'card',
    createdAt: '2025-07-10T10:30:00Z'
  },
  {
    id: 'pay_2',
    courseId: 'course_2',
    userId: 'user_2',
    amount: 149.99,
    currency: 'USD',
    status: 'completed',
    paymentMethod: 'card',
    createdAt: '2025-07-08T14:20:00Z'
  }
];
